import { Typography } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface EmailAlertMessageProps {
  message?: string;
}

export const EmailAlertMessage = ({ message = undefined }: EmailAlertMessageProps) => {
  const { t } = useTranslation();
  if (message) {
    return <Typography>{message}</Typography>;
  }

  return (
    <>
      <Typography>{t('profile->>EmailAlertMessage.The account has been created.')}</Typography>
      <Typography>
        {t(
          'profile->>EmailAlertMessage.An email has been sent to the email stated in the registration form.'
        )}
      </Typography>
      <Typography>
        {t('profile->>EmailAlertMessage.Please follow the steps provided within the email.')}
      </Typography>
    </>
  );
};
